import React, { useContext } from "react";
import style from "./index.module.scss";
import { Tooltip } from "antd";
import SignStatus from "./components/SignStatus";
import { Link } from "react-router-dom";
import { StuSignInListItem, StuSignStatus } from "API/signIn";
import classNames from "classnames";
import moment from "moment";
import useDeviceType from "Utils/useDeviceType";
import { CourseContext } from "../../../Store";
import { SignType } from "API/signIn";

interface ListItemProps {
    data: StuSignInListItem;
}

export default function ListItem({ data }: ListItemProps) {
    const { basename } = useContext(CourseContext);
    const { isPC } = useDeviceType();

    return (
        <div
            className={classNames(style.root, {
                [style.digitalRoot]: data.type === SignType.Number,
                [style.normalRoot]: data.type === SignType.Normal,
                [style.liveRoot]: data.type === SignType.Live
            })}>
            <h1 className={style.title}>
                <Tooltip title={data.title}>{data.title}</Tooltip>

                {isPC && <SignStatus state={data.signStatus} />}
            </h1>

            {!isPC && data.signStatus === StuSignStatus.Timeout && (
                <span className={style.mobileEnd}>[活动已结束]</span>
            )}

            <div className={style.info}>
                {data.signStatus === StuSignStatus.Timeout && isPC && (
                    <span className={style.end}>[活动已结束]&nbsp;&nbsp;</span>
                )}
                {data.type !== SignType.Live && (
                    <span>
                        <span>
                            开始时间{" "}
                            {moment(data.startTime).format("MM-DD HH:mm")}
                        </span>
                        {data.signStatus === StuSignStatus.Timeout && (
                            <span>
                                {" "}
                                ｜ 结束时间{" "}
                                {moment(data.endTime).format("MM-DD HH:mm")}
                            </span>
                        )}
                    </span>
                )}
            </div>

            <div className={style.tools}>
                {data.signStatus === StuSignStatus.Idle && (
                    <Link to={`${basename}/signin/${data.id}/${data.type}`}>
                        前往参与
                    </Link>
                )}
                {data.signStatus !== StuSignStatus.Idle && (
                    <Link to={`${basename}/signin/${data.id}/${data.type}`}>
                        查看活动
                    </Link>
                )}
            </div>

            {!isPC && <SignStatus state={data.signStatus} />}
        </div>
    );
}
